import React, { Component } from "react";
import UsuarioDetalle from "./usuario_detalle";

export default class Pefil extends Component {
  render() {
    return <UsuarioDetalle {...this.props} ruta="perfil"></UsuarioDetalle>;
    //return "hola"
  }
}
